import req from "@/utils/axios.js";

export default {
    getWeComUserInfo(code) {// 传 code 到后端，获取用户信息
        return req.post("/wxShop/auth", {
            state: 'STATE123',
            firm_region_uuid: 1,
            code: code,
        }); 
    },
    getUserInfo() {// 获取用户信息
        return req.get("/wxShop/userInfo");
    },
    myDepartments() {// 获取我的部门
        return req.get("/wxShop/myDepartments");
    },
    // 门店店员企微邀请码
    shopClerkWeComQRCode(data) {// 门店店员企微邀请码
        return req.get("/wxShop/code/shopClerkWeComQRCode",{...data});
    },
    // 邀请用户小程序码
    addUserCode(data) {// 邀请用户小程序码
        return req.get("/wxShop/code/addUserCode",{...data});
    }
}
